import { Dispatch } from "redux";
import { getToken } from "services/token.service";
import { addToLog } from "redux/LogBox/LogBox.actions";
import { Mill } from "models";
import { GET_MILLS } from "endpoints";

const configuration = (window as any).configuration;
const AWS_URL = configuration.awsUrl;

export enum MillSelectorActions {
  SetMills = "mill_selector/set_mills",
  SetSelectedMill = "mill_selector/set_selected_mill",
  SetSelectedLine = "mill_selector/set_selected_line",
  SetMillFetchFailed = "form/fetch_mills_invalidated",
}

export interface SetMillsAction {
  type: MillSelectorActions.SetMills;
  payload: Mill[];
}

export interface SelectMillAction {
  type: MillSelectorActions.SetSelectedMill;
  payload: Mill;
}

export interface SelectLineAction {
  type: MillSelectorActions.SetSelectedLine;
  payload: string;
}

export const setMills = (mills: Mill[]): SetMillsAction => {
  return {
    type: MillSelectorActions.SetMills,
    payload: mills,
  };
};

export const selectMill = (selectedMill: Mill): SelectMillAction => {
  return {
    type: MillSelectorActions.SetSelectedMill,
    payload: selectedMill,
  };
};

export const selectLine = (lineId: string): SelectLineAction => {
  return {
    type: MillSelectorActions.SetSelectedLine,
    payload: lineId,
  };
};

export const fetchMills = (clientId: string) => {
  const client = { clientId: clientId };
  const body = JSON.stringify(client);

  return async (dispatch: Dispatch) => {
    try {
      const token = await getToken();
      const response = await fetch(AWS_URL + GET_MILLS, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        } as HeadersInit,
        method: "post",
        body,
      });

      if (!response.ok) {
        const errorMsg = await response.text();
        throw new Error(errorMsg);
      }

      const data = await response.json(); //mockupMills;
      const mills = Array.isArray(data) ? data : [];

      dispatch(setMills(mills));
    } catch (e) {
      const msg = (e as any).message || e;

      console.error(msg);
      dispatch(addToLog({ text: msg, severity: "error" }));
      dispatch({ type: MillSelectorActions.SetMillFetchFailed });
    }
  };
};
